const Colors = {
  // Humanos Colores
  primaryHumano: "rgba(0,187,236)",
  huMyHome: "rgba(161,216,132)",
  huMyLive: "rgba(139,219,223)",
  huMyHealth: "rgba(255,88,93)",
  huMyCar: "rgba(255,178,91)",
  huMyCompany: "rgba(167,164,224)",
  grayHuman: "#f0efef",
  primaryLight: "#82D8F0",
  success: "#28a745",
  error: "#FF2C2C",
  white: "#FFFFFF",
  whiteTransparentBlue: "#DAF3FA",
  icon: "#636e72",
  backgroundColor: "#f0efef",

  //Primera Colores
  primaryPrimera: "rgba(33,78,158)",
  darkBluePrimera: "rgba(0,48,87)",
  darkGreenPrimera: "rgba(0,177,137)",
  LightGreenPrimera: "rgba(107,205,178)",
  yellowPrimera: "rgba(255,182,0)",

  //Components
  pickerGray: "gray",

  greenHuman: "#ABDB93",

  // Text Colors
  txt: "#212529",
  txtDetail: "#8c9091",

  lineColor: "#E5E5E5",
  grey: "#e2e2e2",
  black: "#000000",
  grayFont: "rgba(140,144,145)",
  inputBg: "#fafafa",
  greyLight: "#f4f4f4",
  grayHealthPlatinum: "#8c9091",
  greyLight2: "#e1e1e1",
  btnSelected: "#c0c0c0",
  darkGrayLabels: "#8c9091",
  darkGray: "#5d5d5d",
  GRAY_80: "#00000080",
  grayClean: "#efecec",

  primaryTransparent: "rgba(0,187,236,0.5)",
  transparent: "rgba(0,0,0,0)",
  middleTransparent: "rgba(255,255,255,0.5)",
  transparent70: "rgba(255,255,255,0.7)",
  backgroundOpaque: "rgba(0,187,236, 0.9)",
  blueTransparent: "#ccdbe6",

  //NB Colors
  nativeBaseIosGray: "#8e8e93",
  nativeBaseIosDarkGray: "#5E5E5E",
  warning: "#856404",
  darkRed: "#8B0000",
};

export default Colors;